import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ExternalOrderNumber } from '../../interfaces/external-order-number/external-order-number';

@Component({
    selector: 'lib-external-order-details',
    templateUrl: './external-order-details.component.html',
    styleUrls: ['./external-order-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExternalOrderDetailsComponent implements OnInit {
  @Input() externalOrderDetails: ExternalOrderNumber | null = null;
  @Input() isLockedByMe: boolean = false;
  @Output() saveExternalOrderNumberEvent = new EventEmitter<ExternalOrderNumber>();

  externalOrderNumber: ExternalOrderNumber = {
    number: "",
    additionalField1: null,
    dateReceived: new Date()
  };

  ngOnInit(): void {
    if (this.externalOrderDetails != null && this.externalOrderDetails != undefined) {
      this.externalOrderNumber = this.externalOrderDetails;
    }
  }

  showExternalDetails(): boolean {
    return ((this.externalOrderNumber?.number.length ?? 0) > 0)
  }

  saveExternalOrderNumber() {
    this.saveExternalOrderNumberEvent.emit(this.externalOrderNumber!);
  }
}
